import fp1_3d from "./img-03.jpg";
import fp1_2d from "./img-04.jpg";
import fp2_3d from "./img-18.jpg";
import fp2_2d from "./img-19.jpg";

const FLOOR_PLAN_KEYS = new Set([
  "./img-03.jpg",
  "./img-04.jpg",
  "./img-18.jpg",
  "./img-19.jpg",
]);

const photoModules = import.meta.glob('./img-*.jpg', { eager: true, import: 'default' }) as Record<string, string>;

const sorted = Object.entries(photoModules)
  .filter(([key]) => !FLOOR_PLAN_KEYS.has(key))
  .sort(([a], [b]) => {
    const na = parseInt(a.match(/img-(\d+)/)?.[1] || "0");
    const nb = parseInt(b.match(/img-(\d+)/)?.[1] || "0");
    return na - nb;
  })
  .map(([, src]) => src);

export const mecholupyImages: string[] = sorted;

export const mecholupyFloorPlans: { image: string; label: string }[] = [
  { image: fp1_3d, label: "Půdorys 3. NP – 3D vizualizace" },
  { image: fp1_2d, label: "Půdorys 3. NP – 2D" },
  { image: fp2_3d, label: "Půdorys 2. NP – 3D vizualizace" },
  { image: fp2_2d, label: "Půdorys 2. NP – 2D" },
];
